import { createAction } from "@ngrx/store";
import { SAPconfigurationModel } from "../models/sap.model";

export const ADD_SAP_CONFIGURATION = createAction(
  "ADD_SAP_CONFIGURATION",
  (sap: SAPconfigurationModel) => sap,
);

export const UPDATE_SAP_CONFIGURATION = createAction(
  "UPDATE_SAP_CONFIGURATION",
  (sap: SAPconfigurationModel) => ({ sap }),
);

export const ADD_SAP_CONFIGURATIONS = createAction(
  "ADD_SAP_CONFIGURATIONS",
  (saps: SAPconfigurationModel[]) => ({
    saps,
  }),
);

export const UPDATE_SAP_CONFIGURATIONS = createAction(
  "UPDATE_SAP_CONFIGURATIONS",
  (sap: SAPconfigurationModel) => ({ sap }),
);
